import { HttpMethod } from '@vision/ui/enums';
import { TicketManagerApiRequest } from '../ticket-manager.api';
import { TicketManagerProjectDeleteArgs } from './projects.api.types';

const TICKET_MANAGER_INNER_LOOP_ENDPOINT = '/v2/inner_loop';

export const buildGetProjectsRequest = ({
  accountId,
  query,
}: {
  accountId: string;
  query?: string;
}): TicketManagerApiRequest => ({
  method: HttpMethod.GET,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${accountId}/projects${query ? `?${query}` : ''}`,
});

export const buildCreateProjectRequest = ({
  accountId,
  name,
  ownerId,
  ticketPrefix,
}: {
  accountId: string;
  name: string;
  ownerId: string;
  ticketPrefix: string;
}): TicketManagerApiRequest => ({
  data: {
    name,
    owner_id: ownerId,
    ticket_ref_id_prefix: ticketPrefix,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${accountId}/projects/`,
});

export const buildUpdateProjectRequest = ({
  accountId,
  name,
  projectId,
  ticketRefIdTemplate,
}: {
  accountId: string;
  name: string;
  projectId: string;
  ticketRefIdTemplate: string;
}): TicketManagerApiRequest => ({
  data: {
    name,
    ticket_ref_id_template: ticketRefIdTemplate,
  },
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${accountId}/projects/${projectId}/update`,
});

export const buildDeleteProjectRequest = ({
  accountId,
  projectId,
}: TicketManagerProjectDeleteArgs): TicketManagerApiRequest => ({
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${accountId}/projects/${projectId}/delete`,
});
